import React, { type JSX } from 'react';

import styles from './ConfirmationModal.module.css';

export default function Body({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  return <div className={styles.Body}>{children}</div>;
}
